import { AssignmentDocumentType } from "./types/command.type.js";

export default {
  data() {
    return {
      assignmentTitle: {
        [AssignmentDocumentType.ComandaFermaTip1]: "COMANDĂ FERMĂ 4",
        [AssignmentDocumentType.ComandaFermaTip2]: "COMANDĂ FERMĂ 1",
        [AssignmentDocumentType.ComandaFermaTip3]: "COMANDĂ FERMĂ 3",
        [AssignmentDocumentType.ComandaFermaTip4]: "COMANDĂ FERMĂ 2",
        [AssignmentDocumentType.ComandaFermaTipSocial]:
          "COMANDĂ FERMĂ SOCIALĂ",
        [AssignmentDocumentType.ComandaFermaArt31]: "COMANDĂ FERMĂ ART.31",
        [AssignmentDocumentType.ContractTip2]: "CONTRACT 1",
        [AssignmentDocumentType.ContractTip3]: "CONTRACT 3",
        [AssignmentDocumentType.ContractTip4]: "CONTRACT 2",
        [AssignmentDocumentType.ContractTipSocial]: "CONTRACT SOCIAL",
        [AssignmentDocumentType.ContractArt31]: "CONTRACT ART.31",
      },

      assignmentNumberTitle: {
        [AssignmentDocumentType.ComandaFermaTip1]: "Număr document fiscal",
        [AssignmentDocumentType.ComandaFermaTip2]: "Număr achiziție S.E.A.P",
        [AssignmentDocumentType.ComandaFermaTip3]: "Număr proces verbal",
        [AssignmentDocumentType.ComandaFermaTip4]:
          "Numar PV de evaluare a ofertelor",
        [AssignmentDocumentType.ComandaFermaTipSocial]:
          "Număr achiziție S.E.A.P/Proces verbal",
        [AssignmentDocumentType.ComandaFermaArt31]:
          "Număr achiziție S.E.A.P/Oferta",
        [AssignmentDocumentType.ContractTip2]: "Număr achiziție S.E.A.P",
        [AssignmentDocumentType.ContractTip3]: "Număr proces verbal",
        [AssignmentDocumentType.ContractTip4]: "Număr proces verbal",
        [AssignmentDocumentType.ContractTipSocial]:
          "Număr achiziție S.E.A.P/Proces verbal",
        [AssignmentDocumentType.ContractArt31]:
          "Număr achiziție S.E.A.P/Oferta",
      },

      assignmentDateTitle: {
        [AssignmentDocumentType.ComandaFermaTip1]: "Data documentului fiscal",
        [AssignmentDocumentType.ComandaFermaTip2]: "Data achiziție",
        [AssignmentDocumentType.ComandaFermaTip3]: "Data proces verbal",
        [AssignmentDocumentType.ComandaFermaTip4]:
          "Data PV de evaluare a ofertelor",
        [AssignmentDocumentType.ComandaFermaTipSocial]:
          "Data achiziție/Proces verbal",
        [AssignmentDocumentType.ComandaFermaArt31]: "Data achiziție/Ofertei",
        [AssignmentDocumentType.ContractTip2]: "Data achiziție",
        [AssignmentDocumentType.ContractTip3]: "Data proces verbal",
        [AssignmentDocumentType.ContractTip4]: "Data proces verbal",
        [AssignmentDocumentType.ContractTipSocial]:
          "Data achiziție/Proces verbal",
        [AssignmentDocumentType.ContractArt31]: "Data achiziție/Ofertei",
      },
    };
  },
};
